import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  COURSE_PAUSE_REQUEST_FILTERS,
  currentFiltersSelector,
  setFilterValue,
} from 'features/courseResume';
import { FILTER_TYPE } from 'data/filterType';
import Field from 'components/Field';
import SuperBatchSelect from 'components/SuperBatchSelect';

function CurrentBatchFilter() {
  const dispatch = useDispatch();
  const { currentBatch } = useSelector(currentFiltersSelector);
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: '0.1rem',
    }),
  };

  const handleOnChange = useCallback(
    (option) => {
      dispatch(
        setFilterValue({
          key: COURSE_PAUSE_REQUEST_FILTERS.currentBatch,
          value: option,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  return (
    <Field
      label="Current Batch"
      labelClassName="h5"
    >
      <SuperBatchSelect
        styles={_styles}
        placeholder="Select from dropdown"
        value={currentBatch}
        onChange={handleOnChange}
      />
    </Field>
  );
}

export default CurrentBatchFilter;
